// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__zuX6E","ellipse":"styles_ellipse__ein4y","arrow":"styles_arrow__Zxgja"};